import styled from 'styled-components'

import { RoundedModal } from '../../../generic'

export const ModalDetails = styled(RoundedModal)`
    .modal-header {
        background: ${({ theme }) => theme['gray-300']};
        border-bottom: 1px solid ${({ theme }) => theme['gray-800']};
    }

    .modal-body {
        background: ${({ theme }) => theme['gray-200']};
    }
`

export const AssetSelectorContainer = styled.div`
    background: var(--gray-300);
    height: 100%;
    padding: 8px;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    overflow: auto;
    position: relative;
`
